import { Component, ElementRef, HostBinding } from '@angular/core';
import { IWizItemRenderer, WizTree, TreeItemWrapper} from '@wizeoo/akm-component-lib';
import { ChronocodeVO } from '@wizeoo/akm-common-lib';

/**
 * Renderer servant a l'affichage des information d'un chronocode
 */
@Component({
  selector: 'chronocode-tree-renderer',
  templateUrl: './chronocode.tree.renderer.html',
})
export class ChronocodeTreeRenderer implements IWizItemRenderer<TreeItemWrapper<ChronocodeVO>, ChronocodeVO> {
  @HostBinding('style.width') elwidth: string = '100%';

  data: ChronocodeVO;
  owner: WizTree<ChronocodeVO>;
  context: TreeItemWrapper<ChronocodeVO>;

  constructor(public elementRef: ElementRef) {}

  /** libellé du renderer */
  public getLabel(): string {
    return this.data.trsLabel;
  }

  /** libellé date de debut date de fin */
  public getRange(): string {
    return this.data.startDateStr + ' - ' + this.data.endDateStr;
  }
}
